var _effectorFileName = "/src/page-content/group-lessons/components/main/main.tsx";
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { ArrowDownIcon, DownloadIcon } from '@radix-ui/react-icons';
import { useUnit } from 'effector-react';
import { GROUP_LESSONS_QUIZ_QUESTIONS } from '@/page-content/group-lessons/constants/quiz-questions';
import { Quiz, QuizResult, QuizResultContent, QuizResultHeader, useQuizContext } from '@/features/quiz';
import { QuizContactForm } from '@/features/quiz/components/quiz-contact-form';
import { COURSE_MAP } from '@/features/quiz/constants/mapping';
import { onGetWorkbookButtonClicked } from '@/features/quiz/model';
import { getGroupQuizResults } from '@/entities/quiz/getGroupQuizResults';
import { getRoadmapQuery } from '@/shared/api/get-roadmap/api';
import { Article } from '@/shared/components/article';
import { $isContactFormSentSuccessfully } from '@/shared/components/contact-form/model';
import CheckMarkIcon from '@/shared/components/icons/checkmark-icon';
import { TextGradient } from '@/shared/components/text-gradient';
import { Badge } from '@/shared/components/ui/badge';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/lib/cn';
import { CardKey } from '../../constants/cards';
export const Main = () => {
  const router = useRouter();
  const {
    onGetWorkbookButtonClick,
    isDownloading,
    isContactFormSentSuccessfully
  } = useUnit({
    onGetWorkbookButtonClick: onGetWorkbookButtonClicked,
    isDownloading: getRoadmapQuery.$pending,
    isContactFormSentSuccessfully: $isContactFormSentSuccessfully
  });
  const [answers, setAnswers] = useState<(number | string)[]>([]);
  const [quizResult, setQuizResult] = useState<CardKey>('common');
  const onDownloadClick = () => {
    onGetWorkbookButtonClick('workbook');
  };
  const handleAnswersChange = (newAnswers: (number | string)[]) => {
    setAnswers(newAnswers);
  };
  const handleViewResultsClick = () => {
    const cardEl = document.getElementById(quizResult);
    const carouselEl = document.getElementById('group-lessons-carousel');
    if (cardEl) {
      // 2 scrolls to ensure scroll on mobile devices works properly (it is impossible to scroll to the card directly)
      carouselEl?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
      cardEl.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  };
  useEffect(() => {
    if (answers.length === GROUP_LESSONS_QUIZ_QUESTIONS.length) {
      const result = getGroupQuizResults(answers);
      setQuizResult(result);
    }
  }, [answers]);
  useEffect(() => {
    if (answers.length === GROUP_LESSONS_QUIZ_QUESTIONS.length) {
      router.replace({
        pathname: router.pathname,
        query: {
          ...router.query,
          quizResult
        }
      }, undefined, {
        shallow: true
      });
    }
  }, [isContactFormSentSuccessfully]);
  useEffect(() => {
    if (router.query.quizResult && typeof router.query.quizResult === 'string') {
      setQuizResult(router.query.quizResult as CardKey);
    }
  }, [router.query.quizResult]);
  const textClasses = 'text-4xl md:text-5xl leading-[115%] font-medium tracking-tight';
  const gradientClasses = 'text-balance bg-gradient-to-br from-black/85 from-30% to-black/60 bg-clip-text text-transparent dark:from-white dark:to-white/40';
  return <Article withGradientBg={true} tag="main" className="relative flex min-h-[60vh] place-content-center pt-20 md:min-h-[calc(100vh-70px)] lg:!py-40 2xl:min-h-[70vh]">
      <div className="absolute inset-0 left-1/2 -z-10 w-screen -translate-x-1/2 overflow-hidden bg-[url('/images/bg-emoji.png')] bg-contain bg-center opacity-40 lg:bg-no-repeat"></div>

      <div className="relative z-10  mb-6 space-y-3 text-center sm:mb-10">
        <h1 className={cn(textClasses, gradientClasses)}>Пройдите короткий квиз</h1>

        <p className="mx-auto max-w-lg text-base text-gray-600 dark:text-white md:text-lg">
          И&nbsp;получите воркбук с&nbsp;основной грамматикой и&nbsp;лексикой для собеседований
        </p>
      </div>

      <div className="flex h-full justify-center">
        <Quiz className="z-10 min-h-[370px] w-full max-w-3xl" questions={GROUP_LESSONS_QUIZ_QUESTIONS} onAnswersChange={handleAnswersChange} contactFormSlot={<QuizContactForm quizResult={quizResult} />}>
          <QuizResult>
            <CheckMarkIcon className="mb-8 h-12 w-12 shrink-0 rounded-full bg-brand-accent-light p-[2px] text-white dark:bg-brand-accent-normal" />

            <QuizResultHeader className="sm:mb-6">
              <TextGradient text="Поздравляем! Вам подойдет курс:" className="mb-2 text-lg tracking-tight md:header-h1" />

              <Badge className="my-4 rounded-sm border-brand-accent-normal bg-brand-accent-superLight px-4 py-2 font-mono !text-base text-black/80 hover:bg-brand-accent-superLight">
                {COURSE_MAP[quizResult]}
              </Badge>

              <div className="text-sm text-muted-foreground">
                <p>Скачайте свой воркбук и&nbsp;посмотрите результаты</p>
              </div>
            </QuizResultHeader>

            <QuizResultContent>
              <Button loading={isDownloading} disabled={isDownloading} onClick={onDownloadClick}>
                Скачать Workbook <DownloadIcon className="ml-2 h-4 w-4" />
              </Button>

              <Button variant="cta" onClick={handleViewResultsClick}>
                Смотреть результаты <ArrowDownIcon className="h-4 w-4 animate-bounce" />
              </Button>
            </QuizResultContent>
          </QuizResult>
        </Quiz>
      </div>
    </Article>;
};